'use client';

import Script from 'next/script';
import { useEffect, useState } from 'react';

interface AcsbAppScriptProps {
  domain: string;
}

const AcsbAppScript = ({ domain }: AcsbAppScriptProps) => {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (window.location.hostname === domain) {
      setShouldRender(true);
    }
  }, [domain]);

  if (!shouldRender) {
    return null;
  }

  return (
    <Script
      id={`acsbapp`}
      strategy='afterInteractive'
      dangerouslySetInnerHTML={{
        __html: `
          (function(){ 
            var s = document.createElement('script'); 
            var h = document.querySelector('head') || document.body; 
            s.src = 'https://acsbapp.com/apps/app/dist/js/app.js'; 
            s.async = true; 
            s.onload = function(){ acsbJS.init(); }; 
            h.appendChild(s); 
          })();
        `,
      }}
    />
  );
};

export default AcsbAppScript;
